module.exports = __webpack_public_path__ + "static/hover_bg_aiti-10d9906d2be8f55e603ca8d4b0fc818f.jpg";